import { Card } from "../../components/layouts/Cards";
import { useSelector, useDispatch } from "react-redux";
import { DemographicFilters } from "./DemographicFilters";

const TurnoutScoreContext = ({ queryString }) => {
  return <></>;
};

export { TurnoutScoreContext };
